module.exports = __webpack_public_path__ + "img/地图_map-road-two.35f74759.svg";